import { useCallback } from "react"
import { PropTypes } from "prop-types"

import useFastField from "../useFastField"
import TextField from "."

export default function TextFieldWrapper({ name, ...rest }) {
  const { field, error, helpers, touched } = useFastField(name)
  const { setValue } = helpers
  const onChange = useCallback((key, value) => setValue(value), [setValue])

  return (
    <TextField
      {...field}
      error={error}
      onChange={onChange}
      touched={field.value ? touched : false}
      {...rest}
    />
  )
}

TextFieldWrapper.propTypes = {
  name: PropTypes.string.isRequired
}
